import { CheckingAccountReceiptComponent } from './dialogs/checking-account-receipt/checking-account-receipt.component';
import { DayTrade } from './screens/courses/day_trade/day-trade.component';
import { SmarttBot } from './screens/courses/smartt-bot/smartt-bot.component';
import { ProfitPro } from './screens/courses/profit-pro/profit-pro.component';
import { ProfitToroTrader } from './screens/courses/profit-toro-trader/profit-toro-trader.component';
import { TransferQuestionsModule } from '../../shared/components/transfer-questions/transfer-questions.module';
import { MainTransferQuestionModule } from '../../shared/components/main-transfer-question/main-transfer-question.module';
import { AccountTypeModule } from '../../shared/components/account-type/account-type.module';
import { DialogYoutubeModule } from '../../shared/components/dialog-youtube/dialog-youtube.module';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { LivePopupModule, TrInputsModule } from '@toro/common/shared/components';

import {
  AlertMessageModule,
  FooterModule,
  InfoMessageModule,
  TrInfoTooltipModule
} from '@toro/common/shared/components';
import { TrAccordionModule } from '@toro/common/shared/components';
import { ModalWelcomePiModule } from '@toro/common/shared/components/modal-welcome-pi/modal-welcome-pi.module';
import {
  CpfCnpjPipeModule,
  FirstNamePipeModule,
  SafePipeModule
} from '@toro/common/shared/pipes';
import {
  TooltipDirectiveModule,
  TrackingDirectiveModule
} from '@toro/common/shared/directives';
import {
  SvgIconModule,
  TrLoadingOverlayModule,
  HubNavModule,
  HubLoginModule,
  HubAuthorizationModule,
  ModalModule,
  LiveSectionAdvisoryModule
} from '@toro/common/shared/components';

import { TransfInfos } from './components/transf-infos/transf-infos.component';
import { TrTabsMobule } from '@hub-workspace/apps/logged-home/src/app/shared/components/tabs/tr-tabs.module';
import { ExclusiveAccountAdvisorComponent } from './components/home-open-account/exclusive-account-advisor.component';
import { TransfInfoTypes } from './components/transf-info-types/transf-info-types.component';
import { LoadingComponent } from '../../shared/components/loading/loading.component';
import { HubLearnCtaComponent } from '../../shared/components/hub-learn-cta/hub-learn-cta.component';
import { HomeLoggedShellComponent } from './home-logged-shell/home-logged-shell.component';
import { HomeLoggedLoaderComponent } from './components/home-logged-loader/home-logged-loader.component';
import { HomeLoggedTransferComponent } from './screens/home-logged-transfer/home-logged-transfer.component';
import { WhyOpenAccountCardComponent } from './components/why-open-account-card/why-open-account-card.component';
import { RegistrationStatusCardComponent } from './components/registration-status-card/registration-status-card.component';
import { InstitutionalTransferComponent } from './components/institutional-transfer/institutional-transfer.component';
import { HomeLoggedTransferModalComponent } from './components/home-logged-transfer-modal/home-logged-transfer-modal.component';
import { UserAcceptCampaignComponent } from './dialogs/user-accept-campaign-dialog/user-accept-campaign-dialog.component';

import { BankInfoBoxModule } from '@hub-workspace/apps/logged-home/src/app/shared/components/bank-info-box/bank-info-box.module';
import { CardLockedComponent } from '@hub-workspace/apps/logged-home/src/app/shared/components/card-locked/card-locked.component';
import { TrCarouselComponent } from './components/tr-carousel/tr-carousel.component';
import { VimeoPopVideoComponent } from '@hub-workspace/apps/logged-home/src/app/shared/components/vimeo-pop-video/vimeo-pop-video.component';
import { SpotlightCardComponent } from './components/spotlight-card/spotlight-card.component';
import { HomeLoggedCoursesComponent } from './screens/courses/courses.component';

import { HomeLoggedStrategiesComponent } from './screens/strategies/strategies.component';
import { LearningWithVideosListComponent } from './components/learning-with-video-list/learning-with-video-list.component';
import { HomeLoggedUserNotFillingComponent } from './screens/home-logged-user-not-filling/home-logged-user-not-filling.component';
import { HomeLoggedUserRegisteringComponent } from './screens/home-logged-user-registering/home-logged-user-registering.component';
import { HomeLoggedUserOpenedAccountComponent } from './screens/home-logged-user-opened-account/home-logged-user-opened-account.component';
import { CardStrategyComponent } from './components/card-strategy/card-strategy.component';
import { LiveSectionBoxModule } from '@toro/common/shared/components/live-section-box/live-section-box.module';
import { AdvisorModule } from '@toro/common/shared/components/advisor/advisor.module';
import { CustomerWalletModule } from '../../shared/modules/customer-wallet/customer-wallet.module';
import { ThankYouPageComponent } from './screens/thank-you-page/thank-you-page.component';
import { OpenedAccountTraderComponent } from './screens/opened-account-trader/opened-account-trader.component';
import { SuitabilityPanelModule } from './components/suitability-panel/suitability-panel.module';
import { HomeLoggedMainComponent } from './home-logged-main/home-logged-main.component';
import { routes } from './home-logged.routes';
import { BreadcrumbComponent } from './components/hub-breadcrumb/hub-breadcrumb.component';
import { DayTradeBenefits } from './components/day-trade-benefits/day-trade-benefits.component';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { HomeTraderModule } from './screens/home-trader/home-trader.module';
import { HomeTraderBalanceComponent } from './screens/home-trader/home-trader-balance/home-trader-balance.component';
import { HomeLineChartModule } from '@hub-workspace/apps/logged-home/src/app/shared/components/home-line-chart/home-line-chart.module';
import { DialogDepositModule } from '@hub-workspace/apps/logged-home/src/app/shared/components/dialog-deposit/dialog-deposit.module';
import { BankInfoTextModule } from '@hub-workspace/apps/logged-home/src/app/shared/components/bank-info-text/bank-info-text.module';
import { ActiveAccountTransferModule } from '@hub-workspace/apps/logged-home/src/app/shared/components/transfer-category/active-account/active-account-transfer.module';
import { OpenAccountTransferModule } from '@hub-workspace/apps/logged-home/src/app/shared/components/transfer-category/open-account/open-account-transfer.module';
import { ProjectedBalanceComponent } from './components/projected-balance/projected-balance.component';
import { ProjectedBalanceAlertboxComponent } from './components/projected-balance-alertbox/projected-balance-alertbox.component';
import { SuitabilityAnticipationDialogComponent } from './dialogs/suitability-santander-anticipation-dialog/suitability-anticipation-dialog.component';
import { LoSantanderComponent } from './components/lo-santander/lo-santander.component';

@NgModule({
  imports: [
    SafePipeModule,
    FormsModule,
    ReactiveFormsModule,
    TrInputsModule,
    ModalModule,
    SwiperModule,
    CommonModule,
    HubNavModule,
    TrTabsMobule,
    RouterModule,
    FooterModule,
    SvgIconModule,
    HubLoginModule,
    MatSlideToggleModule,
    HomeLineChartModule,
    BankInfoBoxModule,
    BankInfoTextModule,
    CpfCnpjPipeModule,
    TrAccordionModule,
    FirstNamePipeModule,
    AlertMessageModule,
    InfoMessageModule,
    HubAuthorizationModule,
    TooltipDirectiveModule,
    TrLoadingOverlayModule,
    TrackingDirectiveModule,
    LiveSectionAdvisoryModule,
    ModalWelcomePiModule,
    DialogYoutubeModule,
    DialogDepositModule,
    AccountTypeModule,
    ActiveAccountTransferModule,
    OpenAccountTransferModule,
    MatButtonModule,
    MainTransferQuestionModule,
    TransferQuestionsModule,
    LiveSectionBoxModule,
    MatSelectModule,
    AdvisorModule,
    CustomerWalletModule,
    HomeTraderModule,
    TrInfoTooltipModule,
    ToastrModule.forRoot({
      timeOut: 0,
      maxOpened: 1
    }),
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }),
    SuitabilityPanelModule,
    HomeTraderModule,
    LivePopupModule,
  ],
  declarations: [
    TransfInfos,
    TransfInfos,
    TransfInfoTypes,
    TransfInfoTypes,
    LoadingComponent,
    ExclusiveAccountAdvisorComponent,
    TrCarouselComponent,
    CardLockedComponent,
    HubLearnCtaComponent,
    CardStrategyComponent,
    SpotlightCardComponent,
    VimeoPopVideoComponent,
    HomeLoggedShellComponent,
    HomeLoggedLoaderComponent,
    HomeLoggedCoursesComponent,
    HomeLoggedTransferComponent,
    WhyOpenAccountCardComponent,
    RegistrationStatusCardComponent,
    HomeLoggedStrategiesComponent,
    InstitutionalTransferComponent,
    LearningWithVideosListComponent,
    HomeLoggedTransferModalComponent,
    HomeLoggedUserNotFillingComponent,
    HomeLoggedUserRegisteringComponent,
    HomeLoggedUserOpenedAccountComponent,
    UserAcceptCampaignComponent,
    ThankYouPageComponent,
    ProfitToroTrader,
    ProfitPro,
    SmarttBot,
    DayTrade,
    OpenedAccountTraderComponent,
    HomeLoggedMainComponent,
    BreadcrumbComponent,
    DayTradeBenefits,
    ProjectedBalanceComponent,
    CheckingAccountReceiptComponent,
    SuitabilityAnticipationDialogComponent,
    ProjectedBalanceAlertboxComponent,
    LoSantanderComponent
  ],
  providers: [
    {
      provide: SWIPER_CONFIG,
      useValue: {
        direction: 'horizontal',
        slidesPerView: 'auto',
        observer: true
      }
    }
  ],
  exports: [HomeLoggedShellComponent, HomeLoggedTransferComponent],
  entryComponents: [
    UserAcceptCampaignComponent,
    HomeTraderBalanceComponent,
    ProjectedBalanceComponent
  ]
})
export class HomeLoggedModule {}
